import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'
import { PrivacyPolicy } from '../Components/Organisms/PrivacyPolicy/PrivacyPolicy'

@Route(RouteID.PRIVACY_POLICY)
export class PrivacyPolicyPage extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.PRIVACY_POLICY}>
                <PrivacyPolicy />
            </RouteGuard>
        )
    }
}
